import React, { useState } from 'react'
import { Button, ButtonGroup, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import InsertChartIcon from '@mui/icons-material/InsertChart'

import ExportButton from './ExportButton'
import { EXPORT_SPLIT_ARROW_BUTTON_SX } from '../style/metricsIndexStyles'

const ExportSplitButton = ({
  onExportPDF,
  onExportExcel,
  label = 'Descargar',
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <ButtonGroup disableElevation>
        <ExportButton disabled={disabled} onClick={onExportExcel} label={label} />

        <Button
          className="download-doble-reports-arrow"
          size="small"
          disabled={disabled}
          onClick={handleToggle}
          sx={EXPORT_SPLIT_ARROW_BUTTON_SX}
        >
          <KeyboardArrowDownIcon />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          disabled={disabled}
          onClick={() => {
            handleClose()
            onExportExcel()
          }}
        >
          <ListItemIcon>
            <InsertChartIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Vista detallada (.csv)</ListItemText>
        </MenuItem>

        <MenuItem
          disabled={disabled}
          onClick={() => {
            handleClose()
            onExportPDF()
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Vista resumida (.pdf)</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

export default ExportSplitButton
